import styled from 'styled-components'

const Container = styled.div`
  flex-direction: column;
  width: 100%;
  height: 100%;

  > div {
    display: grid;
    grid-template-columns: 77px auto;
    gap: 6px;
  }
`
const Content = styled.div`
  margin: 10px 0 20px;

  > .gatsby-image-wrapper {
    align-self: baseline;
  }

  > p {
    max-width: 200px;
  }

  @media(min-width: ${props => props.theme.mediaQuery.smallpc}) {
    align-items: center;

    > img {
      height: 77px;
    }
  }
`
const TextWrapper = styled.div`
  flex-direction: column;
  > p {
    padding-right: 14px;
  }
`

export { Container, Content, TextWrapper }
